import { action } from 'typesafe-actions'
import { PatientTypes } from './types'
import { IAxiosResponse, IPaginator, ISearch } from '../root.types'
import { Patient } from '../../application/models/patient/patient'

/* Action resetar state */
export const resetCreate = () => action(PatientTypes.RESET_CREATE)

export const resetPaginator = () => action(PatientTypes.RESET_PAGINATOR)

/* Action procurar por busca*/
export const changeSearch = (search: ISearch) => action(PatientTypes.CHANGE_SEARCH, { search })

/* Actions para carregar todos pacientes */
export const loadPatients = (paginator?: IPaginator) => action(PatientTypes.LOAD_PATIENT_REQUEST, { paginator })

export const loadPatientSuccess = (response: IAxiosResponse<Patient[]>) => action(PatientTypes.LOAD_PATIENT_SUCCESS, response)

export const loadPatientFailure = () => action(PatientTypes.LOAD_PATIENT_FAILURE)

/* Actions para buscar um paciente */
export const findPatientRequest = (patientId: string) => action(PatientTypes.FIND_PATIENT_REQUEST, { patientId })

export const findPatientSuccess = (response: IAxiosResponse<Patient>) => action(PatientTypes.FIND_PATIENT_SUCCESS, response)

export const findPatientFailure = () => action(PatientTypes.FIND_PATIENT_FAILURE)

/* Actions para criar um novo paciente */
export const createPatientRequest = (patient: Patient, avatar?: any) => action(PatientTypes.CREATE_PATIENT_REQUEST, { patient, avatar })

export const createPatientSuccess = (response: IAxiosResponse<Patient>) => action(PatientTypes.CREATE_PATIENT_SUCCESS, response)

export const createPatientFailure = () => action(PatientTypes.CREATE_PATIENT_FAILURE)

/* Actions para atualizar um paciente existente*/
export const updatePatientRequest = (patient: Patient, avatar?: any) => action(PatientTypes.UPDATE_PATIENT_REQUEST, { patient, avatar })

export const updatePatientSuccess = (response: IAxiosResponse<Patient>) => action(PatientTypes.UPDATE_PATIENT_SUCCESS, response)

export const updatePatientFailure = () => action(PatientTypes.UPDATE_PATIENT_FAILURE)

/*Actions para avatar */
export const changeAvatarFile = (avatar?: File) => action(PatientTypes.CHANGE_AVATAR_FILE, { avatar })

export const changeAvatarImg = (avatar?: any) => action(PatientTypes.CHANGE_AVATAR_IMG, { avatar })

export const loadAvatarRequest = (userId: string) => action(PatientTypes.LOAD_AVATAR_REQUEST, { userId })

export const loadAvatarSuccess = (avatar: any) => [
    changeAvatarImg(avatar),
    action(PatientTypes.LOAD_AVATAR_SUCCESS)
]

export const loadAvatarFailure = () => action(PatientTypes.LOAD_AVATAR_FAILURE)

export const removeAvatarRequest = (userId: string) => action(PatientTypes.REMOVE_AVATAR_REQUEST, { userId })

export const removeAvatarSuccess = () => action(PatientTypes.REMOVE_AVATAR_SUCCESS)

export const removeAvatarFailure = () => action(PatientTypes.REMOVE_AVATAR_FAILURE)